import React from 'react'
import { Highlight } from '@node-space/ui-components'
import { getHighlightType, titleCase } from 'utils/utils'

interface TransactionStatusHighlightProps {
  status: string
}

export const TransactionStatusHighlight = ({ status }: TransactionStatusHighlightProps) => {
  return (
    <Highlight key={`${status}-highlight`} type={getHighlightType(status?.toUpperCase())}>
      {titleCase(status)}
    </Highlight>
  )
}
